<template>
    <div class="login-form d-flex align-items-center">
      <form class="sign-in-sign-up-form w-100" ref="form" data-url="admin/users/register" >
            <div class="text-center mb-4">
                <img :src="logoUrl" alt="" class="img-fluid logo">
            </div>
            <div class="form-row">
                <div class="form-group col-12">
                    <h6 class="text-center mb-0">{{ $t('hi', {object: $t('there')}) }}!</h6>
                    <label class="text-center d-block">{{ $t('register_your_account') }}</label>
                </div>
            </div>

            <app-form-group
                type="select"
                v-if="demoCredentials"
                v-model="loginRole"
                :label="$t('login_as')"
                list-value-field="name"
                :list="selectableRole"
            />

            <app-form-group
                    :label="$t('name')"
                    type="text"
                    v-model="formData.name"
                    :placeholder="$placeholder('your', 'name')"
                    :error-message="$errorMessage(errors, 'name')"
            />

            <app-form-group
                    :label="$t('legal_name')"
                    type="text"
                    v-model="formData.legal_name"
                    :placeholder="$placeholder('your', 'legal_name')"
                    :error-message="$errorMessage(errors, 'legal_name')"
            />

            <app-form-group
                type="select"
                :label="$t('industry_type')"
                list-value-field="name"
                v-model="formData.industry_type"
                :chooseLabel="$t('industry_type')"
                :list="industry"
                placeholder="Industry Type"
                :error-message="$errorMessage(errors, 'industry_type')"
            />


            <app-form-group
                type="select"
                :label="$t('company_size')"
                list-value-field="name"
                placeholder="Company Size"
                v-model="formData.company_size"
                :chooseLabel="$t('company_size')"
                :list="companySize"
                :error-message="$errorMessage(errors, 'company_size')"
            />

            <app-form-group
                    :label="$t('short_name')"
                    type="text"
                    v-model="formData.short_name"
                    :placeholder="$placeholder('your', 'short_name')"
                    :error-message="$errorMessage(errors, 'short_name')"
            />

<!--        <app-form-group-->
<!--            :label="$t('Phone')"-->
<!--            type="text"-->
<!--            v-model="formData.phone"-->
<!--            :placeholder="$placeholder('your', 'phone')"-->
<!--            :error-message="$errorMessage(errors, 'phone')"-->
<!--        />-->

        <app-form-group
            :label="$t('phone_number')"
            type="tel-input"
            v-model="formData.phone"
            :placeholder="$placeholder('your','phone')"
            :error-message="$errorMessage(errors, 'phone')"
        />

            <app-form-group
                    :label="$t('email')"
                    type="email"
                    v-model="formData.email"
                    :placeholder="$placeholder('your', 'email')"
                    :error-message="$errorMessage(errors, 'email')"
            />

<!--            <app-form-group
                    :label="$t('password')"
                    type="password"
                    v-model="formData.password"
                    :placeholder="$placeholder('your', 'password')"
                    :error-message="$errorMessage(errors, 'password')"
                    :show-password="true"
            />-->

            <div class="form-row">
                <div class="form-group col-12">
                    <app-submit-button
                        btn-class="d-inline-flex btn-block text-center btn-primary"
                        :label="$t('register')"
                        :loading="loading"
                        @click="submitData"
                    />
                </div>
            </div>

            <div class="form-group" v-if="!demoCredentials">
              <div class="d-flex flex-row align-items-center justify-content-between">
                <div v-for="page in JSON.parse(pages)" :key="page.id" >
                    <a v-if="page.slug === 'privacy-policy'" :href="urlGenerator('page/' + page.slug)" target="_blank">{{ page.name }}</a>
                    <a v-if="page.slug === 'terms-and-condition'" :href="urlGenerator('page/' + page.slug)" target="_blank">{{ page.name }}</a>
                </div>
              </div>
              <div class="d-flex flex-row align-items-center justify-content-center mt-5">
                Already have an account? <a class="ml-2" :href="urlGenerator('/admin/users/login')">Login</a>
              </div>
                <div class="col-12">
                    <p class="text-center mt-5 footer-copy">
                        {{ $t('copyright') }} @ {{ new Date().getFullYear() }} {{ $t('by') }} {{ appName }}
                    </p>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import ThemeMixin from "../../Mixin/Global/ThemeMixin";
    import FormHelperMixins from "../../Mixin/Global/FormHelperMixins";
    import {MAIL_SETTINGS_LIST} from "../../Config/apiUrl";
    import {axiosGet} from "../../Helper/AxiosHelper";
    const {SELECTABLE_INDUSTRIES, SELECTABLE_COMPANY_SIZE} = require("../../../tenant/Config/ApiUrl");
    export default {
        name: "Login",
        mixins: [ThemeMixin, FormHelperMixins],
        props: {
            logoUrl: {
                required: false
            },
            appName: {
                required: false
            },
            previousPage: {
                required: false
            },
            pages: {
                required: false
            },
          subscriptionPackage: {
              type: Number,
              default: 0
          },
          companySize: {
              type: Array,
              default: []
          },
          industry: {
              type: Array,
              default: []
          },
            demo: {}
        },
        data() {
            return {
                loginRole: '',
                // formData: {
                //     provider: 'smtp',
                //     name: 'smtp',
                // }
            }
        },
        mounted() {},
        methods: {
          submitData() {
            this.message = '';
            this.loading = true;
            this.formData.description = 'description';
            this.formData.external_url = '';
            this.formData.active = true;
            this.formData.subscription_package = this.subscriptionPackage;
            this.formData.enable_trial = true;
            this.save(this.formData);
          },

          afterSuccess({data}) {
            window.location.href = '/admin/users/login';
          },
          afterFinalResponse() {
          },
          // getMailSettings(provider = null) {
          //   console.log('getMailSettings');
          //   provider = provider ? `/${provider}` : '';
          //   const url = `${MAIL_SETTINGS_LIST}${provider}`;
          //   axiosGet(url).then(({data}) => {
          //
          //     if (!Object.keys(data).length) {
          //       this.promptActivable = true
          //     }else {
          //       this.testMailButton = true
          //     }
          //
          //     if (data.provider) {
          //       this.formData = Object.keys(data).length ? data : {provider: 'smtp'};
          //     }else {
          //       this.formData = {provider: this.formData.provider}
          //     }
          //     console.log("formData.provider", this.formData);
          //   });
          // },
        },
        computed: {
            demoCredentials(){
                return this.demo ? JSON.parse(this.demo) : '';
            },
            selectableRole(){
                return [{ id: '', name: this.$t('select_role') }]
                    .concat(Object.keys(this.demoCredentials).map((item) => {
                        return {
                            id: item,
                            name: this.demoCredentials[item].role,
                        }
                    }))
            },
            loginRoleUpdate(){
                return this.loginRole
            }
        },
        watch: {
            loginRoleUpdate: {
                handler: function (role){
                    this.formData.password = role ? this.demoCredentials[role].password : '';
                    this.formData.email = role ? this.demoCredentials[role].email: '';
                }
            },
            // 'formData.name': {
            //   handler: function (provider) {
            //     this.getMailSettings('smtp');
            //   },
            //   immediate: true
            // },
        }

    }
</script>
